export default {
    de: {
        title: 'Einkommen',
        occupationTypeLabel: 'Arbeitsverhältnis',
        occupationTypeDescription: 'Bitte geben Sie Ihr Hauptbeschäftigungsverhältnis an. Diese Angabe kann Einfluß auf die Konditionen haben.',
        occupationType_employee: 'Angestellter',
        occupationType_worker: 'Arbeiter',
        occupationType_officer: 'Beamter',
        occupationType_freelancer: 'Freiberufler',
        occupationType_selfEmployed: 'Selbständiger',
        occupationType_retiree: 'Rentner',
        occupationType_pensioner: 'Pensionär',
        occupationType_unemployed: 'Arbeitslos',
        occupationType_houseMaker: 'Sonstiges',
        incomeLabel_monthlyNetCase: 'Monatliches Nettoeinkommen',
        incomeLabel_annualNetCase: 'Jährliches Nettoeinkommen',
        incomeDescription_common: 'Sollte Ihr Einkommen variable Gehaltsanteile enthalten, tragen Sie Ihr niedrigstes Nettoeinkommen der letzten drei Monate ein. Runden Sie dabei bitte nicht auf oder ab.',
        incomeDescription_annualNetCase: 'Bitte tragen Sie den Jahresüberschuss des letzten Kalenderjahres ein. Der Jahresüberschuss ist das Betriebsergebnis nach Steuern inkl.  Einkommenssteuer, Kirchensteuer und Solidaritätszuschlag.',
        incomePlaceholder: 'Betrag in EUR',
        incomeIsRequiredSpecialError: 'Einkommen ist ein Pflichtfeld',
        numberOfSalariesPerYearLabel: 'Anzahl der Monatsgehälter',
        numberOfSalariesPerYear_12: '12',
        numberOfSalariesPerYear_13: '13',
        numberOfSalariesPerYear_moreThan13: '> 13',
        isOnProbationPeriodLabel: 'Probezeit',
        occupationBeginLabel: 'Beginn der Beschäftigung',
        isLimitedOccupationLabel: 'Das Arbeitsverhältnis ist',
        isLimitedOccupation_yes: 'befristet',
        isLimitedOccupation_no: 'unbefristet',
        occupationLimitedUntilLabel: 'Ende der Befristung',
        employerAddressCountryLabel: 'Land des Arbeitgebers',
        employerAddressCountry_isDE: 'Deutschland',
        employerAddressCountry_isNotDE: 'Anderes Land',
        postalAddressBlockLabel: 'Wohnanschrift des Darlehensnehmers',
        yes: 'Ja',
        no: 'Nein',
        submit: 'Weiter',
        submitDescription: 'kostenlos und unverbindlich',
    },
};
